import { colors2, UI_BODY_DF } from "oolib";
import React from "react";

export const CreateNewCard = ({ onClick, text }) => {
  return (
    <button
      style={{
        border: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "4px",
        border: `1px solid ${colors2.grey30}`,
        background: colors2.grey5,
        minHeight: "30rem",
        height: "100%",
        cursor: "pointer",
      }}
      onClick={onClick}
    >
      <UI_BODY_DF>{text}</UI_BODY_DF>
    </button>
  );
};
